import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-plug-fill text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold font-heading text-white">
                {t("site.name")}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300">
              {t("site.tagline")}
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-fill text-sm text-secondary-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-fill text-sm text-secondary-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors"
                aria-label="抖音"
              >
                <i className="ri-tiktok-fill text-sm text-secondary-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              {t("footer.products")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/category/industrial-connectors"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  工业级插接器
                </Link>
              </li>
              <li>
                <Link
                  to="/category/household-connectors"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  家用插接配件
                </Link>
              </li>
              <li>
                <Link
                  to="/category/construction-connectors"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  施工专用插接装置
                </Link>
              </li>
              <li>
                <Link
                  to="/category/waterproof-series"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  防水插接系列
                </Link>
              </li>
              <li>
                <Link
                  to="/category/custom-solutions"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  定制插接方案
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              {t("footer.company")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t("nav.about")}
                </Link>
              </li>
              <li>
                <Link
                  to="/articles"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t("nav.articles")}
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              {t("footer.support")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t("footer.privacy")}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t("footer.terms")}
                </a>
              </li>
              <li className="pt-1">
                <p className="text-sm text-secondary-400">
                  客服热线：400-888-6688
                </p>
              </li>
              <li>
                <p className="text-sm text-secondary-400">
                  邮箱：service@jiujiucha.com
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">{t("footer.copyright")}</p>
          <p className="text-xs text-secondary-400">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-secondary-200 transition-colors cursor-pointer"
            >
              沪ICP备XXXXXXXX号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}